import type { CustomerCardStoreState } from '../types/CustomerCardTypes';
import type { BusinessEntity } from '../types/businessConversion.types';
import { CARD_OPERATION_KIND, CARD_OPERATION_STEP } from '../constants';
import { getSelectedSearchResult } from './selectors';

const getConvertToBusinessStep = (rootState: CustomerCardStoreState) => {
    const operation = rootState.customerCard?.operation;
    return operation?.kind === CARD_OPERATION_KIND.CONVERT_TO_BUSINESS ? operation.step : null;
};

export const getIsBusinessSearchStep = (rootState: CustomerCardStoreState) =>
    getConvertToBusinessStep(rootState) === CARD_OPERATION_STEP.SEARCH;

export const getIsBusinessEditStep = (rootState: CustomerCardStoreState) =>
    getConvertToBusinessStep(rootState) === CARD_OPERATION_STEP.EDIT;

export const getSelectedBusiness = (rootState: CustomerCardStoreState) =>
    (getSelectedSearchResult(rootState) as BusinessEntity | null) ?? null;

export const getSelectedBusinessEntityId = (rootState: CustomerCardStoreState) =>
    getSelectedBusiness(rootState)?.businessEntityId ?? null;

export const getSelectedBusinessName = (rootState: CustomerCardStoreState) => getSelectedBusiness(rootState)?.businessName ?? null;

export const getIsDealSoldOrContracted = (rootState: CustomerCardStoreState) =>
    rootState.customerCard?.isDealSoldOrContracted ?? false;
